import * as React from 'react';

function SensorIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M15.56 17.98c-1.37 0-2.49-1.12-2.49-2.49S14.19 13 15.56 13s2.49 1.12 2.49 2.49-1.12 2.49-2.49 2.49m0-3.49c-.55 0-.99.45-.99.99s.45.99.99.99.99-.45.99-.99-.45-.99-.99-.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 22.02h-2.98C5.82 22.02 2 18.2 2 13.5v-2.98C2 5.82 5.82 2 10.52 2h2.98c4.7 0 8.52 3.82 8.52 8.52v2.98c0 4.7-3.82 8.52-8.52 8.52M10.52 3.5c-3.87 0-7.02 3.15-7.02 7.02v2.98c0 3.87 3.15 7.02 7.02 7.02h2.98c3.87 0 7.02-3.15 7.02-7.02v-2.98c0-3.87-3.15-7.02-7.02-7.02z"
  }));
}

export { SensorIcon };
